import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const domStoreSiteConfig: SiteConfigFn<Record<string, never>> = ({ api }) => {
	return {
		shouldLoadSiteFeature: !!api.env.getExperiments()?.['specs.thunderbolt.dom_store'],
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'domStore'

export const config = { site: domStoreSiteConfig, name }
